var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-list" },
    [
      _c(
        "Collapse",
        {
          staticClass: "notice-item",
          model: {
            value: _vm.spread,
            callback: function($$v) {
              _vm.spread = $$v
            },
            expression: "spread"
          }
        },
        [
          _c(
            "Panel",
            { attrs: { name: "1" } },
            [
              _vm._v(" 数据缺失提醒 "),
              _c("Table", {
                attrs: {
                  slot: "content",
                  "show-header": false,
                  columns: _vm.columns,
                  data: _vm.noticeList
                },
                slot: "content"
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { transfer: false, "footer-hide": "", "z-index": _vm.rank },
          model: {
            value: _vm.showNoticeDetail,
            callback: function($$v) {
              _vm.showNoticeDetail = $$v
            },
            expression: "showNoticeDetail"
          }
        },
        [
          _c("div", [
            _c("span", { staticClass: "notice-detail" }, [
              _vm._v(_vm._s(_vm.noticeDetail))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }